import { isQuestionVisible } from './schemaEvaluator';

/** Proforma wording (staff only) for a row the primary-age rule left out (TDI-708). */
export const NOT_ASKED_PRIMARY_AGE = 'Not asked: primary-age child';

/**
 * Why a question was not asked of this respondent, when the reason is a rule
 * about the child rather than a missing answer, so clinicians never read
 * "No answer given" for a question the parent never saw (R-030).
 *
 * A question counts as left out by the primary-age rule when the form context
 * stored on the instance says the child is at primary school, the question
 * (or its section) is hidden under that context, and it would have been shown
 * for a child whose school phase is unknown. A question hidden for any other
 * reason (an earlier answer, another respondent's section) is not reported.
 *
 * @param {object} question - schema question node
 * @param {object|null} section - the question's schema section
 * @param {object} answers - the respondent's answers on this instance
 * @param {object|null} context - the instance's stored form context
 * @returns {string|null} the line to show instead of an answer, or null
 */
export function notAskedReason(question, section, answers, context) {
  if (!question || !context || context.schoolPhase !== 'primary') return null;
  const shownUnder = (ctx) => isQuestionVisible(answers || {}, section && section.visibleWhen, ctx)
    && isQuestionVisible(answers || {}, question.visibleWhen, ctx);
  const withoutPhase = { ...context };
  delete withoutPhase.schoolPhase;
  if (!shownUnder(context) && shownUnder(withoutPhase)) return NOT_ASKED_PRIMARY_AGE;
  return null;
}
